import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {

    const userType = sessionStorage.getItem('userType');

    console.log("UserType:", userType); // Check userType value
    if (userType !== "super admin") {
        return <Navigate to="/users" replace />;
    }

    return children ? children : <Outlet />;
};

export default ProtectedRoute;
